<template>
  <ModalContainer :queryParam="activeQueryParam" ref="modalContainer" size="lg">
    <fieldset>
      <b-card>
  
        <h4 class="text-center mb-2">{{
          esView 
            ? 'Ver Item Imagen' 
            : esCrear
              ? 'Crear Item Imagen' 
              : 'Editar Item Imagen'
        }}</h4>
  
        <!-- Vista solo lectura -->
        <div v-if="esView" class="ver-imagen">
          <h5 class="section-title">Información del Ítem</h5>
          <b-row class="mb-2">
            <b-col md="4" class="mb-1">
              <small class="text-muted d-block">Código</small>
              <span class="font-weight-bold h5 mb-0 d-block">{{ imagen.codigo || 'No disponible' }}</span>
            </b-col>
            <b-col md="4" class="mb-1">
              <small class="text-muted d-block">Tipo Imagen</small>
              <span class="font-weight-bold h5 mb-0 d-block">{{ tipoImagenTexto }}</span>
            </b-col>
            <b-col md="4" class="mb-1">
              <small class="text-muted d-block">Nombre</small>
              <span class="font-weight-bold h5 mb-0 d-block">{{ imagen.nombre || 'No disponible' }}</span>
            </b-col>
          </b-row>

          <hr>

          <h5 class="section-title">Precios</h5>
          <table class="table table-sm table-precios">
            <thead>
              <tr>
                <th>Entidad</th>
                <th class="text-right">Precio</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="fila in filasPrecios" :key="fila.entidad">
                <td class="font-weight-bold">{{ fila.entidad }}</td>
                <td class="text-right">{{ fila.precio }}</td>
              </tr>
            </tbody>
          </table>

          <hr>

          <h5 class="section-title">Estados de Cobertura</h5>
          <div class="d-flex flex-wrap mb-2">
            <div class="estado-chip mr-4 mb-2" v-for="estado in estadosCobertura" :key="estado.label">
              <span :class="estado.activo ? 'text-success' : 'text-danger'">
                <i :class="estado.activo ? 'fas fa-check-circle' : 'fas fa-minus-circle'" class="mr-1"></i>
                {{ estado.label }}
              </span>
            </div>
          </div>

          <hr>

          <h5 class="section-title">Establecimientos</h5>
          <b-row>
            <b-col md="6" v-for="est in establecimientosActivos" :key="est.id">
              <div class="d-flex align-items-center mb-1">
                <span class="font-weight-bold mr-2 text-uppercase">{{ est.nombre }}</span>
                <span :class="est.activo ? 'text-success' : 'text-danger'">
                  <i :class="est.activo ? 'fas fa-check-circle' : 'fas fa-times-circle'" class="mr-1"></i>
                  {{ est.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Formulario editar/crear -->
        <div class="row" v-else>
  
          <hr class="col-12">
  
          <div class="col-6 mb-1">
            <label>Código: <span class="text-danger">*</span></label>
  
            <b-form-input
              v-model="imagen.codigo"
              type="text"
            />
          </div>
  
          <div class="col-6 mb-1">
            <label>Tipo Imagen: <span class="text-danger">*</span></label>

            <v-select
              id="tipoImagen"
              v-model="imagen.tipoImagen"
              placeholder="Buscar por tipo de imagen."
              :options="tipoImagenOpts"
              :reduce="(option) => option"
              label="text"
              class="d-inline-block w-100"
            />
          </div>
  
  
          <div class="col-12 mb-1">
            <label>Nombre: <span class="text-danger">*</span></label>
            <b-form-input
              v-model="imagen.nombre"
              type="text"
            />
          </div>
  
          <hr class="col-12">
    
          <b-row class="col-12">
            <h6 class="col-12">Precio:</h6>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N1</label>
              <InputNumber v-model="imagen.precios.issfa_n1" decimal/>
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N2</label>
              <InputNumber v-model="imagen.precios.issfa_n2" decimal/>
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">IESS N1</label>
              <InputNumber v-model="imagen.precios.iess_n1" decimal/>
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">PARTICULAR</label>
              <InputNumber v-model="imagen.precios.particular" decimal/>
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSPOL N1</label>
              <InputNumber v-model="imagen.precios.isspol_n1" decimal/>
            </div>
  
          </b-row>
  
          <hr class="col-12">
  
  
          <b-row class="col-12">
            <h6 class="col-12">Estados:</h6>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">IESS</label>
  
              <b-form-checkbox 
                v-model="imagen.estados.iess" 
                switch
              />
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">ISSFA</label>
  
              <b-form-checkbox 
                v-model="imagen.estados.issfa" 
                switch
              />
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">ISSPOL</label>
  
              <b-form-checkbox 
                v-model="imagen.estados.isspol" 
                switch
              />
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">PARTICULAR</label>
  
              <b-form-checkbox 
                v-model="imagen.estados.particular"
                switch
              />
            </div>
          </b-row>

          <hr class="col-12">

          <b-row class="col-12">
            <h6 class="col-12">Establecimientos:</h6>
            <div class="row estab-grid col-12">
              <div
                v-for="est in imagen.establecimientosEstado"
                :key="est.value"
                class="col-6 mb-2"
              >
                <div class="estab-item">
                  <span class="estab-label">{{ est.text }}</span>
                  <b-form-checkbox
                    v-model="est.activo"
                    switch
                    class="mb-0"
                  />
                </div>
              </div>
            </div>
          </b-row>
  
          <div class="col-12 d-flex justify-content-end mt-3">
            <b-button 
              @click="onSaveImagen" 
              variant="primary" 
              class="mx-2"
            >
              Guardar Imagen
            </b-button>
  
            <!-- <b-button @click="onCancel" variant="danger">
              Cancelar
            </b-button> -->
          </div>
  
        </div>
      </b-card>
    </fieldset>

  </ModalContainer>
</template>

<script>


import vSelect from "vue-select";
import { fetchTipoImagenSelect }       from '@/views/imagen/services/tipoImagen';
import { ModalContainer, InputNumber } from '@/shared/components'
import { getEstablecimientoLS } from "../../../../shared/helpers";
import { carteraImagenService } from "../../services";
import { establecimientosService } from '@/views/administracion/services';

export default {

  components: {
    vSelect,
    ModalContainer,
    InputNumber
  },

  async created() {
    this.tipoImagenOpts = await fetchTipoImagenSelect();
    this.loadingEstablecimientos = true;
    this.establecimientosList = await establecimientosService.getForSelect();
    this.loadingEstablecimientos = false;
    await this.getData();
    this.syncEstablecimientosEstado();
  },


  data(){
    return {
    imagen: {
      id: null,
      codigo: null,
      tipoImagen: null,
      nombre: null,
      establecimiento: '',
      establecimientosEstado: [],

      precios: {
        issfa_n1: "0",
        issfa_n2: "0",
          iess_n1: "0",
          particular: "0",
          isspol_n1:" 0",
        },

      estados: {
        iess: false,
        issfa: false,
        isspol: false,
        particular: false
      },
      estadoJson: {},
      precioJson: {},
    },


      tipoImagenOpts:[],
      establecimientosList: [],
      loadingEstablecimientos: false,
    }
  },



  methods:{
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },
    mapEstablecimientosEstado(establecimientosStr = '') {
      const safeVal = establecimientosStr || '';
      const ids = Array.isArray(safeVal)
        ? safeVal.map(e => (e.id ? e.id : e)).map(i => String(i).trim())
        : safeVal
            .toString()
            .split(',')
            .map(i => i.trim())
            .filter(Boolean);

      const baseList =
        (this.establecimientosList && this.establecimientosList.length
          ? this.establecimientosList
          : []) || [];

      // Si no hay lista cargada, devolvemos items a partir de ids; si tampoco hay ids, lista vacía
      const listToUse =
        baseList.length > 0
          ? baseList
          : ids.map(id => ({ value: id, text: id })) || [];

      // Si no hay ids, igual devolvemos la lista con todos inactivos para que se muestren.
      return listToUse.map(est => ({
        ...est,
        activo: ids.includes(String(est.value)),
      }));
    },
    syncEstablecimientosEstado() {
      this.imagen.establecimientosEstado = this.mapEstablecimientosEstado(
        this.imagen.establecimiento
      );
    },


    clearForm(){

      this.imagen = {
        id         : null,
        codigo     : null,
        tipoImagen : null,
        nombre     : null,
        establecimiento: '',
        establecimientosEstado: [],

        precios: {
          issfa_n1   : "0",
          issfa_n2   : "0",
          iess_n1    : "0",
          particular : "0",
          isspol_n1  : "0",
        },

        estados: {
          iess       : false,
          issfa      : false,
          isspol     : false,
          particular : false
        },
        estadoJson: {},
        precioJson: {},
      }
    },


    async getData(){
      this.clearForm();
      const tokenSave   = this.$route.query.saveImage;
      const tokenView   = this.$route.query.viewImage;
      const tokenCreate = this.$route.query.createImage;

      if(tokenCreate) return;

      const tokenImagen = tokenView || tokenSave;
      if(!tokenImagen) return;

      const response = await carteraImagenService.getAll({ tokenImagen });
      if(!response || !response.imagenes) return;

      const imagen = response.imagenes[0];

      const tipoImagen = {
        value: imagen.tipoImagen.id,
        text : imagen.tipoImagen.descripcion
      }

      const estados  = this.parseFlexibleJson(imagen.estadoJson);
      const precios  = this.parseFlexibleJson(imagen.precioJson);

      const imagenMap = {
        tokenImagen     : imagen.token,
        establecimiento : imagen.establecimiento,
        establecimientosEstado: this.mapEstablecimientosEstado(imagen.establecimiento),
        codigo          : imagen.codigo,
        tipoImagen      : tipoImagen,
        nombre          : imagen.nombre,
        estados         : {
          iess       : !!estados.iess,
          issfa      : !!estados.issfa,
          isspol     : !!estados.isspol,
          particular : !!estados.particular,
        },
        precios         : {
          issfa_n1    : precios.issfa_n1    ?? "0.00",
          issfa_n2    : precios.issfa_n2    ?? "0.00",
          iess_n1     : precios.iess_n1     ?? "0.00",
          particular  : precios.particular  ?? (imagen.precio ? String(imagen.precio) : "0.00"),
          isspol_n1   : precios.isspol_n1   ?? "0.00",
        }
      }

      this.imagen = imagenMap;
    },


    async onSaveImagen(){

      const validationForm = this.validateForm();
      if(!validationForm) return;

      const establecimiento = this.esCrear 
        ? getEstablecimientoLS()?.id
        : this.imagen.establecimiento;

      const imagenToSave = {
        tokenImagen     : this.imagen.tokenImagen || null,
        establecimiento : this.imagen.establecimientosEstado
          .filter(e => e.activo)
          .map(e => e.value)
          .join(",") || establecimiento,
        codigo          : this.imagen.codigo,
        tipoImagen      : this.imagen.tipoImagen?.value,
        nombre          : this.imagen.nombre,
        estados         : this.imagen.estados ? JSON.stringify(this.imagen.estados) : null,
        precios         : this.imagen.precios ? JSON.stringify(this.imagen.precios) : null
      }


      if(!imagenToSave.estados){
        console.error('no hay dato de estados en el imagen a actualizar');
      }

      if(!imagenToSave.precios){
        console.error('no hay dato de precios en el imagen a actualizar');
      }

      const responseSave = this.esCrear 
        ? await carteraImagenService.createItem(imagenToSave)
        : await carteraImagenService.updateItem(imagenToSave);
        

      if(!responseSave){
        await this.$swal({
          icon: 'error',
          text: 'Error al guardar la imagen',
          showConfirmButton: true
        });

        return;
      }

      await this.$refs.modalContainer.closeModal();

      await this.$swal({
        icon: 'success',
        title: 'Imagen guardada correctamente',
        showConfirmButton: true
      });

      this.$router.go(0);
    },


    validateForm(){

      const errors = [];

      if(!this.imagen.codigo)
        errors.push('Debe ingresar el codigo de la imagen');

      if(!this.imagen.nombre)
        errors.push('Debe ingresar el nombre de la imagen');

      if(!this.imagen.tipoImagen?.value)
        errors.push('Debe seleccionar el tipo de imagen');

      if(errors.length === 0) return true;
      const mensajeError = errors.join(', ');

      this.$swal({
        title: "Error",
        text: mensajeError,
        icon: "error",
        showConfirmButton: true,
      });

      return false;
    }

  },

  computed: {
    activeQueryParam() {
      const query = this.$route.query;
      if ('viewImage' in query)   return 'viewImage';
      if ('saveImage' in query)   return 'saveImage';
      if ('createImage' in query) return 'createImage';
      return 'viewImage'; 
    },

    esView() {
      return this.activeQueryParam === 'viewImage';
    },

    esCrear() {
      return this.activeQueryParam === 'createImage';
    },

    establecimientosActivos() {
      const estIds = (this.imagen.establecimiento || '')
        .toString()
        .split(',')
        .map(e => e.trim())
        .filter(Boolean);

      const list =
        (this.establecimientosList && this.establecimientosList.length
          ? this.establecimientosList
          : []) || [];

      if (!list.length && !estIds.length) return [];

      const listToUse = list.length ? list : estIds.map(id => ({ value: id, text: id }));

      return listToUse.map(est => ({
        id: est.value ? String(est.value) : '',
        nombre: est.text,
        activo: estIds.includes(String(est.value)),
      }));
    },

    tipoImagenTexto() {
      return (this.imagen.tipoImagen && (this.imagen.tipoImagen.text || this.imagen.tipoImagen.descripcion)) || 'No disponible';
    },

    filasPrecios() {
      const format = (valor) => {
        const num = Number(valor || 0);
        return `$${num.toFixed(2)}`;
      };
      return [
        { entidad: 'ISSFA N1', precio: format(this.imagen.precios.issfa_n1) },
        { entidad: 'ISSFA N2', precio: format(this.imagen.precios.issfa_n2) },
        { entidad: 'IESS N1',  precio: format(this.imagen.precios.iess_n1) },
        { entidad: 'ISSPOL N1', precio: format(this.imagen.precios.isspol_n1) },
        { entidad: 'PARTICULAR', precio: format(this.imagen.precios.particular) },
      ];
    },

    estadosCobertura() {
      return [
        { label: 'IESS',       activo: !!this.imagen.estados.iess },
        { label: 'ISSFA',      activo: !!this.imagen.estados.issfa },
        { label: 'ISSPOL',     activo: !!this.imagen.estados.isspol },
        { label: 'PARTICULAR', activo: !!this.imagen.estados.particular },
      ];
    }

  },


  watch: {
    '$route.query.saveImage': {
      deep: true,
      handler(newValue) {
        if(newValue) this.getData();
      }
    },

    '$route.query.viewImage': {
      deep: true,
      handler(newValue) {
        if(newValue) this.getData();
      }
    },

    '$route.query.createImage': {
      deep: true,
      handler(newValue) {
        if(newValue) this.getData();
      }
    },
    establecimientosList() {
      this.syncEstablecimientosEstado();
    },
    'imagen.establecimiento'(val) {
      if (val !== undefined) {
        this.syncEstablecimientosEstado();
      }
    },
  }
}
</script>

<style scoped>
.ver-imagen .section-title {
  font-weight: 700;
}
.table-precios thead th {
  background: #dfe3e8;
}
.estado-chip {
  padding: 4px 0;
}

.estab-grid .col-6 {
  padding-left: 8px;
  padding-right: 8px;
}

.estab-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f9fbff;
  min-height: 38px;
}

.estab-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344050;
}
</style>
